import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TokenStorageService } from '../../core/_services/token-storage.service';
import { EventconfigStoreService } from '../../shared/eventconfig-store.service';
import { EventAuthService } from '../../shared/event-auth.service';
import { UserAssignService } from '../../shared/user-assign.service';
import { MediaLibraryStoreService } from '../../shared/media-library-store.service';
import { MyStream } from '../../shared/myStream';
import { environment } from '../../../environments/environment';
import { EventsetupStoreService } from 'app/shared/eventsetup-store.service';

@Component({
  selector: 'lse-event-shell',
  templateUrl: './event-shell.component.html',
  standalone: false
})
export class EventShellComponent implements OnInit, OnDestroy {
  isLoggedIn = false;
  isReady = false;
  uMode: 'int' | 'ext' = 'ext';
  uAssigendStream: MyStream = { ip: 'ext' };
  eToken: string;
  eSetup: any;

  cssDoc = document;

  private sub: Subscription | undefined;
  private uInternalInterval: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private tokenStorage: TokenStorageService,
    private es: EventconfigStoreService,
    private eventAuthService: EventAuthService,
    private us: UserAssignService,
    private eventSetupService: EventsetupStoreService,
    private mediaLib: MediaLibraryStoreService,
    private renderer: Renderer2
  ) {}


  ngOnInit(): void {
      const token = this.activatedRoute.snapshot.paramMap.get('token');
      if (token) {
        this.eToken = token;
        this.tokenStorage.setEventToken(token);
        this.es.setToken(token);

      // Der Mediathek-Kontext wird hier gelesen, nicht in der LoginComponent: bei einem
      // Reload mit gültiger Session läuft der Login nicht erneut, der Header braucht
      // Rücksprung-Link und Event-Menü aber weiterhin.
      this.mediaLib.captureFromQueryParams(this.activatedRoute.snapshot.queryParams);
      if (this.mediaLib.isFromMediaLibrary()) {
        // Die Event-Liste kam mit der Login-Antwort und liegt seitdem im sessionStorage.
        // Die LoginComponent überschreibt sie mit frischen Daten, wenn sie doch läuft.
        this.mediaLib.setEvents(this.tokenStorage.getUser()?.tokens);
      }

      this.isLoggedIn = !!this.tokenStorage.getToken();
      this.sub = this.tokenStorage.loggedIn$.subscribe(() => {
        this.isLoggedIn = true;
      });

      if (this.us.getInternal()) {
        this.uMode = 'int';
        this.us.getInternalStream().subscribe(p => {
          this.uAssigendStream = p;
        });
      } else {
        this.uAssigendStream = { ip: 'ext' };
      }
      this.es.initEvent(token).subscribe({
        next: (p) => {
          if (p === null || p === undefined) {
            window.location.href = environment.apiUrl + environment.eventPrefix + 'misc/no_token.php';
            return;
          }
          this.es.setInitCipher(p.token);
          this.eventSetupService.getEventSetup();
          this.isReady = true;
        },
        complete: () => {
          this.eventSetupService.setup$.subscribe((data) => {
            this.eSetup = data;
            this.loadLogo();
            this.loadStyle(environment.cssPrefix + this.eSetup.style);
            console.log('Event setup loaded', this.eSetup);
          })

        },
        error: (err) => {
          console.error('Error initializing event', err);
        }
      });
    }
  }

    loadStyle(styleName: string) {
    const head = this.cssDoc.getElementsByTagName('head')[0];
    const themeLink = this.cssDoc.getElementById('client-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const clientStyle = this.cssDoc.createElement('link');
      clientStyle.id = 'client-theme';
      clientStyle.rel = 'stylesheet';
      clientStyle.href = `${styleName}`;
      head.appendChild(clientStyle);
    }
  }

  loadLogo() {
    setTimeout(() => {
      const dynamicWidth = this.cssDoc.createElement('STYLE') as HTMLStyleElement;
      dynamicWidth.id = 'secondLogo';
      dynamicWidth.innerHTML = this.es.getSecondLogoWidth();
      this.renderer.appendChild(this.cssDoc.head, dynamicWidth);
    }, 200);
  }

  ngOnDestroy(): void {
    clearInterval(this.uInternalInterval);
    this.sub?.unsubscribe();
  }
}
